<template>
    <v-sheet elevation="5" :class="$style['container']">
        <!-- <div class="ma-5">
            <v-progress-linear v-if="countyList.length < 1" indeterminate height="5" ></v-progress-linear>
        </div> -->
        <v-form ref="marriage_ws_form" v-model="marriageWsFormValidity" >
            <v-layout row wrap justify-center>
                <v-flex xs8 sm6 md4 lg3>
                    <v-autocomplete
                        v-model="formData.countyClerkFacilityId"
                        :disabled="!canEdit"
                        label="County"
                        hint="County office will you get the marriage license from?"
                        persistent-hint
                        :items="countyList"
                        item-text="description"
                        item-value="id"
                        required
                        :rules="requiredRule"
                        v-on:change="checkSelectedCounty"
                        autocomplete="no"
                        no-data-text="Loading counties..."
                    ></v-autocomplete>
                </v-flex>
            </v-layout>
            <v-layout row wrap v-show="formData.countyClerkFacilityId">
                <v-flex xs12 lg6 px-8 py-0>
                    <marriage-ws-applicant
                        :isRequired="true"
                        :canEdit="canEdit"
                        ref="marriageWsApplicant1"
                        title="Applicant 1"
                        @applicant="getApplicant"
                        :applicantProp="formData.applicants[0]"
                        :applicantNum="1"
                    />
                </v-flex>
                <v-flex xs12 lg6 px-8 py-0>
                    <marriage-ws-applicant
                        :isRequired="true"
                        :canEdit="canEdit"
                        ref="marriageWsApplicant2"
                        title="Applicant 2"
                        @applicant="getApplicant"
                        :applicantProp="formData.applicants[1]"
                        :applicantNum="2"
                    />
                </v-flex>
            </v-layout>
            <div :class="$style['bottom-controls']" v-show="formData.countyClerkFacilityId">
                <v-btn color="secondary" @click="print" :disabled="isPrinting">Print</v-btn>
            </div>
        </v-form>
        <div class="text-center">
            <v-dialog v-model="printOnlyDialog" max-width="500" persistent >
                <v-card>
                    <v-card-title></v-card-title>
                    <v-card-text>
                        The {{selectedCounty}} County Clerk office is not accepting online worksheets at this time.
                        You may still fill out and print this worksheet to take with you to the County Clerk office to save time.
                    </v-card-text>
                    <v-card-actions>
                        <v-btn color="primary" block @click="printOnlyDialog = false">Close</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>
    </v-sheet>
</template>

<script>
import MarriageWsApplicant from './MarriageWsApplicant.vue'
import lookupService from '@/services/lookupService'

export default {
    name: 'marriage-ws-form',
    components: {
        MarriageWsApplicant
    },
    props: {
        canEdit: Boolean,
        applicantsProp: Array,
        countyProp: Number
    },
    data: () => {
        return {
            marriageWsFormValidity: false,
            countyList: [],
            formData: {
                countyClerkFacilityId: null,
                applicants: [{}, {}]
            },
            printOnlyCountyIds: [15128],
            printOnlyDialog: false,
            isPrinting: false
        }
    },
    mounted () {
        this.load()
    },
    computed: {
        requiredRule () {
            return [
                v => {
                    return !!v || 'Required'
                }
            ]
        },
        printOnlyCountySelected () {
            return this.printOnlyCountyIds.includes(this.formData.countyClerkFacilityId)
        },
        selectedCounty () {
            return (this.countyList.find(x => x.id === this.formData.countyClerkFacilityId) || { description: ' ' }).description
        }
    },
    methods: {
        load () {
            lookupService.GetCountyClerkCountyFacilities(this.$http).then(response => {
                this.countyList = response.data
            })
        },
        validate () {
            var valid = this.$refs.marriage_ws_form.validate()
            return valid
        },
        getApplicant (applicant, num) {
            if (!this.formData.applicants[num]) {
                this.formData.applicants.push(applicant)
                return
            }

            this.formData.applicants[num] = applicant
        },
        getFormData () {
            this.applicants = []
            this.$refs.marriageWsApplicant1.getApplicant()
            this.$refs.marriageWsApplicant2.getApplicant()
            this.$emit('form-data', this.formData)
        },
        print () {
            //already printing
            if (this.isPrinting) return
            this.isPrinting = true
            if (this.printOnlyCountySelected) {
                this.applicants = []
                this.$refs.marriageWsApplicant1.getApplicant()
                this.$refs.marriageWsApplicant2.getApplicant()
                this.$emit('print-no-save')
            } else {
                this.$emit('on-print')
            }
        },
        checkSelectedCounty () {
            if (this.canEdit && this.printOnlyCountyIds.includes(this.formData.countyClerkFacilityId)) {
                this.$nextTick()
                this.printOnlyDialog = true
            }
            this.$emit('county-changed', this.formData.countyClerkFacilityId)
        }
    },
    watch: {
        countyProp: {
            handler (value) {
                this.formData.countyClerkFacilityId = value
            },
            deep: false
        },
        applicantsProp: {
            handler (value) {
                this.formData.applicants = value
            },
            deep: true
        }
    }
}
</script>

<style module>
.container {
    width: 100%;
    max-width: 2160px;
    padding: 24px;
}

.bottom-controls {
    position: relative;
    display: flex;
    justify-content: flex-end;
}
</style>
